import { useState, useEffect } from "react";
import { getSiteConfig } from "@/config/siteConfigs";

// Типізація продукту
interface Product {
  goid: string;
  name: string;
  nettoprice: number;
  priceexch: number;
  imageUrl: string;
}

interface ApiResponse {
  data: Array<{
    goid: string;
    name: string;
    nettoprice: string; // Ціна приходить як рядок
    priceexch: string;
    files: {
      image: Record<string, string>; // Зображення, ключі можуть бути різні
    };
  }>;
}

const useProductData = (goid: string, table?: string) => {
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null); // Для обробки помилок
  const siteConfig = getSiteConfig();

  useEffect(() => {
    const fetchProductData = async () => {
      setLoading(true);
      setError(null); // Скидаємо помилки перед кожним новим запитом

      try {
        // Завжди додаємо параметр table (якщо не передано, використовуємо 'good')
        const apiUrl = `https://crm.hixa.eu/external/goodsapi/?legid=1&language=${
          siteConfig.language
        }&type=good&goid=${goid}&table=${table || "good"}`;
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: "Bearer DH345DFGDGb32FDsf03876SDFSdf13",
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch product data");
        }

        const data: ApiResponse = await response.json();

        // Перевіряємо, чи є дані
        if (!data || !data.data || data.data.length === 0) {
          throw new Error("Product data is empty");
        }

        const productData = data.data[0];

        // Беремо перше зображення (якщо воно є), або використовуємо шаблонне зображення
        const imageUrl = productData.files.image
          ? Object.values(productData.files.image)[0] // Беремо перший елемент з масиву зображень
          : "/images/Shop/template.webp"; // Якщо зображень немає, використовуємо шаблон

        const productDetails: Product = {
          goid: productData.goid,
          name: productData.name,
          nettoprice: parseFloat(productData.nettoprice), // Перетворюємо ціну на число
          priceexch: parseFloat(productData.priceexch),
          imageUrl: imageUrl,
        };

        setProduct(productDetails);
      } catch (error: any) {
        setError(error.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    if (goid) {
      fetchProductData();
    }
  }, [goid, table, siteConfig.language]);

  return { product, loading, error };
};

export default useProductData;
